/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Divider from '../../../../common/Divider';
import { queryVariables } from '../../../../utils/queryURL';
import { useAuth } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import GiftListRecommendationsSFContainer from '../../GiftListRecommendationsSFContainer';

const MobileGiftListLogin = () => {
    const params = queryVariables();
    const { loginByRedirect } = useAuth();

    return (
        <>
            <h1>Welcome Gift List Customer</h1>
            <p>
                Please sign in to securely access your personal gifting
                information.
            </p>
            <div className="row align-center margin-bottom-2x margin-top-2x">
                <Button
                    variant="contained"
                    className="buttonHD"
                    onClick={async () => {
                        if (params.custNbr) {
                            await loginByRedirect({}, { custNbr: params.custNbr });
                        } else {
                            await loginByRedirect();
                        }
                    }}
                >
                    Sign In
                </Button>
            </div>
            <Divider text="or" />
            <p>
                Start shopping with your Gift List now by creating an
                account.
            </p>
            <div className="row align-center margin-bottom-2x margin-top-2x">
                <Button
                    variant="contained"
                    className="buttonHDSecondary"
                    onClick={async () => {
                        if (params.custNbr) {
                            await loginByRedirect({}, { register: 'Y', custNbr: params.custNbr });
                        } else {
                            await loginByRedirect({}, { register: 'Y' });
                        }
                    }}
                >
                    Create Account
                </Button>
            </div>
            <GiftListRecommendationsSFContainer />
        </>
    );
};

export default MobileGiftListLogin;
